<span class="text-{{isIncreasePercentage()?'success':'danger'}}" *ngIf="item?.plan && item?.plan?.value>0">
    <small><i class="fas fa-arrow-{{isIncreasePercentage() ? 'up' : 'down'}}"></i>
        {{percentagePerMonth()}}</small></span>

